import React from 'react';
import { useSelector } from 'react-redux';
import Hero from './Hero';
import FAQ from './FAQ';
import Pricing from './Stripe/Pricing';
import Footer from './Footer';

const Landing = () => {
    const loggedIn = useSelector((state) => state.user.loggedIn);
    const isSubscribed = useSelector((state) => state.user.isSubscribed);

    return (
    <div className="bg-white dark:bg-brand-dark-900">
        <div id="hero">
            <Hero isAuthenticated={loggedIn} isSubscribed={isSubscribed} />
        </div>
        <div id="faq">
            <FAQ />
        </div>
        {!isSubscribed && (
            <div id="pricing">
                <Pricing />
            </div>
        )}
        <Footer />
    </div>
    );
};

export default Landing;
